var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { property } from "lit/decorators.js";
import { html, css } from "lit";
import { PICBase, PIC, customElement } from "../Internals";
let PICPicker = class PICPicker extends PICBase {
    constructor() {
        super();
        this.show = "hidden";
        this.shouldHide = true;
    }
    connectedCallback() {
        super.connectedCallback();
        PIC.getInstance.events.addPicker(this);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        PIC.getInstance.events.removePicker(this);
    }
    static get styles() {
        const defaultStyle = css `
        .picker.hidden{
            display:none;
        }
        .picker.fade{
            animation: fadeOut ease 0.3s;
            -webkit-animation: fadeOut ease 0.3s;
            -moz-animation: fadeOut ease 0.3s;
        }
        .picker.show{
            display: block;
            animation: fadeIn ease 0.3s;
            -webkit-animation: fadeIn ease 0.3s;
            -moz-animation: fadeIn ease 0.3s;
        }
        ::-webkit-scrollbar {
            //width: 0px;
            //background: transparent; /* make scrollbar transparent */
        }
        @keyframes fadeIn {
            0% {opacity:0;}
            100% {opacity:1;}
        }
        @-moz-keyframes fadeIn {
            0% {opacity:0;}
            100% {opacity:1;}
        }
        @-webkit-keyframes fadeIn {
            0% {opacity:0;}
            100% {opacity:1;}
        }
        @keyframes fadeOut {
            0% {opacity:1;}
            100% {opacity:0;}
        }
        @-moz-keyframes fadeOut {
            0% {opacity:1;}
            100% {opacity:0;}
        }
        @-webkit-keyframes fadeOut {
            0% {opacity:1;}
            100% {opacity:0;}
        }

        .picker {
            text-align: center;
            font-size: 1em;
            -webkit-touch-callout: none;
            -webkit-user-select: none;
            -khtml-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            width: 100%;
            height: 48px;
            position: absolute;
            height: fit-content;
            top: 0px;
            z-index: 10;
        }

        /*.calendarbody {
            width: 30%;
            max-width: 20%;
            min-width: 300px;
            border: 1px solid black;
        }*/

        `;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    focus() {
        return;
    }
    validateSubmit() {
        return true;
    }
    toggle() {
        if (this.show == "show") {
            this.show = "fade";
        }
        else if (this.show == 'hidden') {
            this.show = 'show';
            PIC.getInstance.events.activePicker = { picker: this, pickerMode: "ignoreLocalScroll" };
        }
        ;
        this.requestUpdate();
    }
    hideEvent() {
        return;
    }
    ;
    hide() {
        var _a;
        if (this.shouldHide) {
            if (this.show == 'show') {
                this.show = 'fade';
                if (((_a = PIC.getInstance.events.activePicker) === null || _a === void 0 ? void 0 : _a.picker) == this)
                    PIC.getInstance.events.activePicker = undefined;
                this.hideEvent();
                this.requestUpdate();
            }
        }
        else {
            this.shouldHide = true;
        }
    }
    handleEnd(e) {
        var _a;
        if (e.animationName == 'fadeOut') {
            this.show = 'hidden';
            if (((_a = PIC.getInstance.events.activePicker) === null || _a === void 0 ? void 0 : _a.picker) == this)
                PIC.getInstance.events.activePicker = undefined;
            this.requestUpdate();
        }
    }
    renderContent() {
        return html ``;
    }
    render() {
        return html `
            ${this.renderCSS(true)}
            <div class="picker ${this.show}" @animationend=${this.handleEnd}>
                ${this.renderContent()}
            </div>
        `;
    }
};
__decorate([
    property()
], PICPicker.prototype, "show", void 0);
PICPicker = __decorate([
    customElement('pic-picker')
], PICPicker);
export { PICPicker };
//# sourceMappingURL=PICPicker.js.map